var exports = {
  "W": "x04b3a21e--571ebd--title",
  "D": "x04b3a21e--571ebd--promotions",
};

module.exports = exports;
